import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { withAreaGetter } from 'providers/AreasConsumers';
import { ADMIN_LEASING_SERVICE_TYPES_READ, ADMIN_LEASING_SERVICE_TYPES_WRITE } from 'constants/rightsCodes';
import { usePermission } from 'providers/RightsHooks';
import PermissionCheck from 'components/common/PermissionCheck';
import BrowserComponent from './BrowserComponent';
import HeaderPortal from 'components/layout/HeaderPortal';
import { areas } from 'constants/areas';
import Portal from 'utils/portal/Portal';
import { IconButton } from '@totalsoft/rocket-ui';
import MergeTypeIcon from '@mui/icons-material/MergeType';
import { useTranslation } from 'react-i18next';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import FlexBox from 'components/common/FlexBox';

const Route = ({ getElemByAreaKey }) => {
  const { t } = useTranslation();
  const historyContext = useHistoryWithContext();

  const canRead = usePermission(ADMIN_LEASING_SERVICE_TYPES_READ);
  const canWrite = usePermission(ADMIN_LEASING_SERVICE_TYPES_WRITE);

  const navigateToLinkings = useCallback(() => {
    historyContext.push('/leasingServiceTypeLinkings');
  }, [historyContext]);

  return (
    <>
      <HeaderPortal />
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <FlexBox gap={0.5}>
          {canRead && (
            <IconButton tooltip={t('LeasingServiceType.ServiceTypeLinkings')} variant='text' color='primary' onClick={navigateToLinkings}>
              <MergeTypeIcon />
            </IconButton>
          )}
          {canWrite && (
            <IconButton
              onClick={() => historyContext.push(`/leasingServiceTypes/new`)}
              type='add'
              fontSize='medium'
              color='transparent'
              tooltip={t('Add')}
            />
          )}
        </FlexBox>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_LEASING_SERVICE_TYPES_READ}>
        <BrowserComponent />
      </PermissionCheck>
    </>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
